import {MdOutlineDirectionsWalk} from 'react-icons/md';
import {
  COLOR_BLACK_1,
  COLOR_WHITE,
} from '../../../../../../config/constants/colorCodes';
import {
  PRIORITY,
  PRIORITY_LABELS,
} from '../../../../../../core/entities/entryTodos/constants';
import {cn} from '../../../../../../lib/classname';

type Props = {
  level: number;
};

export const PriorityTag = ({level}: Props) => {
  const label = PRIORITY_LABELS[level as keyof typeof PRIORITY_LABELS] || 'Low';

  return (
    <div
      className={cn(
        'h-24 w-fit flex justify-center items-center gap-[1px] px-8 py-[1px] text-sm border-[1px] rounded-full',
        {
          'bg-notification-1 border-notification-1 text-white':
            level === PRIORITY.HIGH,
          'bg-accent-1 border-accent-1 text-white': level === PRIORITY.MEDIUM,
          'bg-white border-line text-black-2': level === PRIORITY.LOW,
        },
      )}
    >
      <MdOutlineDirectionsWalk
        fill={level === PRIORITY.LOW ? COLOR_BLACK_1 : COLOR_WHITE}
        size={16}
      />
      {label}
    </div>
  );
};
